<style lang="less" scoped>
.evaluating_result{
	position: absolute;
	width: 100%;
	height: 100%;
	padding-bottom: 54px;
	box-sizing: border-box;
	display: -webkit-box; display:flex;
	-webkit-box-align: center; align-items: center;
	-webkit-box-pack: center; justify-content: center;
	flex-direction: column;
	.icon{
		width: 86px;
		margin-bottom: 34px;
	}
	h3{
		text-align: center;
		font-size: 18px;
		margin-bottom: 18px;
	}
	p{
		font-size: 12px;
		color: #999;
		padding: 0 46px 120px;
	}
	.jump{
		width: 100%;
		text-align: center;
		position: fixed;
		left: 0;
		bottom: 80px;
		span{
			color: #999;
			font-size: 12px;
			font-weight: 700;
		}
	}
}
</style>

<template>
	<!-- Main evaluating_result -->
	<section class="evaluating_result">
		<img class="icon" src="../assets/evaluation_result.png">
		<h3>{{detail.risk_grade}}</h3>
		<p v-if="detail.risk_grade && type[detail.risk_grade]">{{type[detail.risk_grade]}}</p>
		<div class="jump">
			<span @click="again">重新测评</span>
		</div>
		<footbtn btn-txt="立即赚钱" :is-on="isActive" @click.native="next"></footbtn>
	</section>
</template>

<script>
	import footbtn from '@flyme/jr/flyme7/component/foot-btn-simple/foot-btn-simple.vue';
	import android from '@flyme/jr/js/android.js';

	import axios from '../axios.js';
	import apis from '../apis.js';

	export default {
		data: function () {
			return {
				detail: {},
				type: {
					'谨慎型': '建议投资低风险产品',
					'稳健型': '建议投资低风险、偏低风险产品',
					'平衡型': '建议投资低风险、偏低风险、中等风险产品',
					'进取型': '建议投资低风险、偏低风险、中等风险、偏高风险产品',
					'激进型': '建议投资低风险、偏低风险、中等风险、偏高风险和高风险产品'
				}
			};
		},
		computed: {
			isActive: function() {
				return true;
			}
		},
		components: {
			footbtn
		},
		created: function () {
			android('setTitle', {
				title: "风险等级测评"
			});
			android('startLoading', {mes: '正在加载'});
			this.getDetail();
		},
		mounted: function () {
		},
		methods: {
			again: function () {
				this.$router.replace({path: '/evaluating'});
			},
			getDetail: function () {
				let _this = this;
				axios.post(apis.risk_grade_query, {}).then(function(d) {
					console.log('risk_grade_query', d);
					_this.detail = d.value;
					android('stopLoading');
				});
			},
			next: function () {
				this.$router.replace({path: '/acctplus/charge'});
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Evaluating_result.vue